import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminContentAutomations from "@/pages/AdminContentAutomations";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/content-automations")({
  head: () => seoHead("/admin/content-automations"),
  component: () => (
    <StaffAdminGate><AdminContentAutomations /></StaffAdminGate>
  ),
});
